export default "__VITE_ASSET__CEM$2TZb__"